<script setup lang="ts">
import { computed } from "vue";

export interface TintProps {
  /** The color of the text. */
  color?: "failure" | "muted" | "success";
  /** The HTML tag to be used. */
  tag?: "p" | "div" | "span"; // keyof HTMLElementTagNameMap;
}

const { color = "muted", tag: customTag } = defineProps<TintProps>();

const tintClassName = {
  failure: "text-error-01",
  muted: "text-disabled-01",
  success: "text-information-01",
};

const computedTag = computed(() => customTag || "span");
</script>

<template>
  <component :is="computedTag" :class="tintClassName[color]" data-testid="clr-tint"
    ><slot
  /></component>
</template>
